<template>
    <div v-if="languageMessage" class="alert alert-info text-center" style="margin-bottom: 10px;">{{ languageMessage }}</div>
    <div class="section text-center mt-2 mb-2" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="section inset mt-1" v-if="!loading_list">
        <div class="wide-block pt-1 pb-1">
            <div class="profile-header">
                <div class="avatar-section">
                    <img v-if="profile.avatar == 'member.jpg'" src="assets/img/sample/avatar/avatar1.png" alt="avatar"
                        class="imaged w-100 rounded" />
                    <img v-else :src="'https://guide.msoftit.com/' + profile.avatar" alt="avatar"
                        class="imaged w-100 rounded" />
                </div>
                <div class="profile-info">
                    <h3>{{ profile.name || currentUser.name }}</h3>
                    <span>{{ currentUser.country_code }} {{ profile.mobile || currentUser.phone }}</span>
                </div>
                <div class="header-actions">
                    <button v-if="canSwitch" class="profile-action-btn qr-btn" :aria-label="$t('switch_profile')"
                        @click="openSwitchModal">
                        <ion-icon name="swap-horizontal-outline"></ion-icon>
                    </button>
                    <button class="profile-action-btn qr-btn" @click="showQrCode = !showQrCode">
                        <ion-icon name="qr-code-outline"></ion-icon>
                    </button>
                </div>
            </div>

            <ul class="listview flush transparent simple-listview no-space mt-1">
                <li v-if="this.profile.zone">
                    <strong class="mal-text">{{$t('my_district')}}</strong>
                    <span class="text-end">{{ this.profile.district }}</span>
                </li>
                <li v-if="this.profile.zone">
                    <strong class="mal-text">{{$t('my_zone')}}</strong>
                    <span class="mal-text">{{ this.profile.zone }}</span>
                </li>
                <li v-if="this.profile.unit">
                    <strong class="mal-text">{{$t('my_unit')}}</strong>
                    <span class="text-end mal-text">{{ this.profile.unit }}</span>
                </li>
                <li v-if="this.profile.unit && currentUser.user_level <= 3">
                    <strong></strong>
                    <router-link class="mal-text custom-button profile-action-btn" :to="'/org/4/' + currentUser.unit_id">
                        <span>
                            {{$t('go_to_branch')}}
                        </span>
                    </router-link>
                </li>
                <li v-if="lajna_member">
                    <strong></strong>
                    <router-link class="mal-text custom-button profile-action-btn" :to="'/lajna/lajna-page'">
                        <span>
                            {{$t('go_to_lajna')}}
                        </span>
                    </router-link>
                </li>
                <li v-if="this.profile.campus">
                    <strong class="mal-text">{{$t('my_campus')}}</strong>
                    <span class="text-end">{{ this.profile.campus }}</span>
                </li>
            </ul>
        </div>
    </div>

    <div v-if="showQrCode" class="qr-scanner-modal" @click.self="showQrCode = false">
        <div class="qr-scanner-content">
            <QrcodeVue3 :width="200" :height="200" :value="qrCodeValue" :qrOptions="{
                typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H'
            }" :image="'assets/logo.png'" :imageOptions="{
                hideBackgroundDots: true, imageSize: 0.4, margin: 0, image: 'assets/logo.png'
            }" :dotsOptions="{
                type: 'extra-rounded', color: '#2355b3', gradient: {
                    type: 'linear',
                    rotation: 0,
                    colorStops: [
                        { offset: 0, color: '#2355b3' },
                        { offset: 1, color: '#2355b3' }
                    ]
                }
            }" :backgroundOptions="{ color: '#ffffff' }" :cornersSquareOptions="{ type: 'dot', color: '#2355b3' }"
                :cornersDotOptions="{ type: undefined, color: '#2355b3' }" fileExt="png" :download="false"
                myclass="my-qur" imgclass="img-qr" downloadButton="my-button"
                :downloadOptions="{ name: 'Wisdom Guide', extension: 'png' }" />
        </div>
    </div>
    <!-- Switch Profile Action Sheet -->
    <div class="modal fade action-sheet" id="switchProfileModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">{{ $t('switch_profile') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div v-if="switching" class="text-center p-2">
                            <div class="spinner-border text-secondary" role="status"></div>
                            <p class="mal-text mt-1">{{ $t('switching_profile') }}</p>
                        </div>
                        <ul v-else class="listview image-listview switch-list">
                            <li v-for="p in switchProfiles" :key="p.member_id" :class="{ active: p.is_active }">
                                <a href="javascript:void(0)" class="item" @click="selectProfile(p)">
                                    <div class="in">
                                        <div>
                                            <header>{{ p.name }}</header>
                                            <p class="mal-text">
                                                <span v-if="p.is_own">{{ $t('my_profile_label') }}</span>
                                                <span v-else-if="p.designation">{{ p.level_label }} · {{ p.designation }}</span>
                                                <span v-else>{{ p.level_label }}</span>
                                            </p>
                                        </div>
                                        <ion-icon v-if="p.is_active" name="checkmark-circle" class="text-primary switch-check">
                                        </ion-icon>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Switch Profile Action Sheet -->

    <div class="section mt-1 mb-1" v-if="!loading_list && profile.member_exist && profile.enable_election">
        <div class="transactions">
            <a href="/#/membership-dashboard" class="item">
                <div class="detail">
                    <img src="https://guide.msoftit.com/uploads/image/1709102511.png" alt="img"
                        class="image-block imaged w48">
                    <div>
                        <strong class="mal-text">{{$t('membership_biodata')}}</strong>
                        <p class="mal-text">{{$t('membership_details_update')}}</p>
                    </div>
                </div>
                <div class="right">
                    <div class="price text-primary"><ion-icon name="chevron-forward-outline"></ion-icon></div>
                </div>
            </a>
        </div>
    </div>
    <div class="section mt-1" v-if="!loading_list">
        <div class="transactions">
            <a href="/#/my-profile/nerpatham" class="item">
                <div class="detail">
                    <img src="https://guide.msoftit.com/uploads/image/1699440085.jpeg" alt="img"
                        class="image-block imaged w48">
                    <div>
                        <strong class="mal-text">{{$t('nerpatham')}}</strong>
                        <p class="mal-text">{{$t('nerpatham_desc')}}</p>
                    </div>
                </div>
                <div class="right">
                    <div class="price text-primary"><ion-icon name="chevron-forward-outline"></ion-icon></div>
                </div>
            </a>
        </div>
    </div>
    <div class="section mt-1" v-if="!loading_list">
        <div class="transactions">
            <router-link to="/clander" class="item">
                <div class="detail">
                    <span class="cal-icon-slot" aria-hidden="true">
                        <ion-icon name="calendar-outline"></ion-icon>
                    </span>
                    <div>
                        <strong>My Calendar</strong>
                        <p>Events &amp; personal schedule</p>
                    </div>
                </div>
                <div class="right">
                    <div class="price text-primary"><ion-icon name="chevron-forward-outline"></ion-icon></div>
                </div>
            </router-link>
        </div>
    </div>
    <div class="section mt-1 mb-1" v-if="!loading_list && profile.member_exist && profile.old_biodata_form">
        <div class="goals">
            <router-link :to="'bio-data'">
                <div class="item">
                    <img src="https://guide.msoftit.com/uploads/image/1709102511.png" alt="img"
                        class="image-block imaged w48">
                    <div class="in">
                        <div>
                            <h4 class="mal-text">{{$t('my_biodata_form')}}</h4>
                            <p class="mal-text">{{$t('biodata_fill_edit')}}</p>
                        </div>
                        <div class="right">
                            <div class="price text-primary"><ion-icon name="chevron-forward-outline"></ion-icon></div>
                        </div>
                    </div>
                    <div class="progress">
                        <div class="progress-bar" :class="this.profile.fillStatus == 100 ? 'bg-success' : 'bg-primary'"
                            role="progressbar" :style="{ width: this.profile.fillStatus + '%' }" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100">{{ this.profile.fillStatus }}%
                        </div>
                    </div>
                </div>
            </router-link>
        </div>
    </div>
    <div class="section mt-1 mb-1" v-if="!loading_list && profile.member_exist">
        <div class="transactions">
            <router-link :to="'/qr-code-scanner'">
                <div class="item">
                    <div class="detail">
                        <img src="https://guide.msoftit.com/uploads/image/1709102533.png" alt="img"
                            class="image-block imaged w48">
                        <div>
                            <h4>{{$t('qr_code_scanner')}}</h4>
                            <p class="mal-text">{{$t('qr_code_attendance_desc')}}</p>
                        </div>
                    </div>
                    <div class="right">
                        <div class="price text-primary"><ion-icon name="chevron-forward-outline"></ion-icon></div>
                    </div>
                </div>
            </router-link>
        </div>
    </div>
    <ul class="listview image-listview inset text mt-1 pt-1 mb-1" v-if="!loading_list && profile">
        <li>
            <router-link :to="'set-password'">
                <a href="javascript:void(0)" class="item">
                    <div class="in">
                        <div>
                            <header>{{$t('change_pin')}}</header>
                        </div>
                    </div>
                </a>
            </router-link>
        </li>
        <li>
            <a href="javascript:void(0)" class="item">
                <div class="in">
                    <div>
                        <header>{{$t('app_version')}}</header>
                        <b> 2.0 </b>
                    </div>
                </div>
            </a>
        </li>
        <li>
            <a href="javascript:void(0)" class="item" @click="logout">
                <div class="in">
                    <div style="color: red;">
                        <b>{{$t('logout')}}</b>
                    </div>
                </div>
            </a>
        </li>
    </ul>

</template>
<script>
import $ from "jquery";
import AuthService from "../services/auth.service";
import UserService from "../services/user.service";
import VersionChecker from "../utils/versionCheck";
import QrcodeVue3 from "qrcode-vue3";
export default {
    name: 'Profile',
    components: {
        QrcodeVue3,
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        // Show the Switch button when this number has more than one profile,
        // or whenever we are currently acting as a switched profile.
        canSwitch() {
            return this.switchProfiles.length > 1 || this.isSwitched;
        },
    },
    data() {
        return {
            profile: [],
            loading_list: false,
            showQrCode: false,
            qrCodeValue: "",
            lajna_member: false,
            switchProfiles: [],
            switching: false,
            isSwitched: false,
            activeMemberId: null,
            ownMemberId: null,
        }
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        }
        this.loading_list = true;
        this.getProfile();
        this.getSwitchableProfiles();
        this.$root.updateParent(this.$t('my_profile'));
    },
    methods: {
        getProfile() {
            var data = {
                user_id: this.currentUser.id
            };
            UserService.authPostRequest('get-my-profile', data).then(
                (response) => {
                    this.profile = response.data.data.list;
                    this.lajna_member = response.data.data.lajna_member;
                    this.qrCodeValue = JSON.stringify({
                        user_id: this.currentUser.id
                    });
                    this.loading_list = false;
                    localStorage.setItem("my_profile", JSON.stringify(this.profile));
                },
            );
        },
        // Load every member profile that shares this login's mobile number.
        getSwitchableProfiles() {
            UserService.authPostRequest('get-switchable-profiles', {
                user_id: this.currentUser.id
            }).then(
                (response) => {
                    const data = response.data.data || {};
                    this.switchProfiles = data.profiles || [];
                    this.isSwitched = !!data.is_switched;
                    this.activeMemberId = data.active_member_id || null;
                    this.ownMemberId = data.own_member_id || null;
                },
            ).catch(() => {
                this.switchProfiles = [];
            });
        },
        openSwitchModal() {
            // Refresh the list so active/own flags are current, then show the sheet.
            this.getSwitchableProfiles();
            $("#switchProfileModel").modal("show");
        },
        selectProfile(p) {
            if (!p || p.is_active) {
                $("#switchProfileModel").modal("hide");
                return;
            }
            this.switchToProfile(p.member_id);
        },
        // Switch the login to act as the given member, then hard-reload with cache cleared.
        // The JWT is unchanged, so this never logs the user out.
        switchToProfile(memberId) {
            this.switching = true;
            UserService.authPostRequest('switch-profile', {
                user_id: this.currentUser.id,
                member_id: memberId
            }).then(
                (response) => {
                    const patch = (response.data.data && response.data.data.user_patch) || {};
                    // Merge switched identity onto the cached user, keeping id + accessToken.
                    const patched = { ...this.currentUser, ...patch };
                    AuthService.setCookie('user', patched);
                    this.$store.commit('auth/loginSuccess', patched);
                    // Drop stale cached profile and reload with caches/service-workers cleared.
                    localStorage.removeItem('my_profile');
                    VersionChecker.forceReload();
                },
            ).catch(() => {
                this.switching = false;
            });
        },
        logout() {
            // Check if user is a public user (QVP public registration)
            const isPublicUser = this.currentUser && this.currentUser.signup_url === 'qvp';
            
            AuthService.logout();
            localStorage.activeMenu = 'Home';
            
            // Redirect public users to /qvp, others to home
            if (isPublicUser) {
                location.replace('/#/qvp');
            } else {
                location.replace('/');
            }
        }
    },
};
</script>
<style>
.col-8 {
    margin-top: -25px !important;
}

.listview {
    font-size: 14px !important;
}

.listview li {
    min-height: 25px !important;
}

.success_label {
    content: "";
    width: 25px;
    height: 25px;
    margin-top: 16px;
    margin-left: 38%;
    background: #1DCC70;
    border-radius: 100%;
    display: flex;
    background-image: url("data:image/svg+xml,%0A%3Csvg width='18px' height='14px' viewBox='0 0 23 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline id='Path' stroke='%23FFFFFF' stroke-width='2.4' points='21.2 2 7.76 18 2 12'%3E%3C/polyline%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center center;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
}

.warning_label {
    content: "";
    width: 35px;
    height: 35px;
    margin-top: 16px;
    margin-left: 36%;
    background: #FFCC00;
    border-radius: 100%;
    display: flex;
    background-image: url("data:image/svg+xml,%0A%3Csvg width='8px' height='8px' viewBox='0 0 8 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Ccircle id='Oval' fill='%23FFFFFF' cx='4' cy='4' r='4'%3E%3C/circle%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center center;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
}

.danger_label {
    content: "";
    width: 35px;
    height: 35px;
    margin-top: 16px;
    margin-left: 36%;
    background: #ff0e0e;
    border-radius: 100%;
    display: flex;
    background-image: url("data:image/svg+xml,%0A%3Csvg width='23px' height='20px' viewBox='0 0 23 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline id='Path' stroke='%23FFFFFF' stroke-width='2.4' points='21.2 2 7.76 18 2 12'%3E%3C/polyline%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center center;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
}

.goals .item p {
    font-size: 10px;
}

.icon-size {
    font-size: 24px;
}

.footer-text {
    font-size: 12px;
}

.price {
    font-size: 50px;
}

.profile-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
}

.avatar-section {
    width: 60px !important;
    height: 60px !important;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}
.avatar-section img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
}

.profile-info {
    flex-grow: 1;
    margin-left: 10px;
}

.profile-info h3 {
    margin: 0;
    font-size: 14px;
}

.profile-info span {
    display: block;
    margin-top: 5px;
    font-size: 13px;
    line-height: 10px;
}

.qr-code-button {
    background: #e6e6e6;
    color: #000748;
    border: none;
    padding: 10px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.qr-code-button ion-icon {
    width: 24px;
    height: 24px;
}

.qr-scanner-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    opacity: 0;
    animation: fadeIn 0.3s forwards;
}

.qr-scanner-content {
    background: white;
    padding: 5px;
    border-radius: 20px;
    text-align: center;
    transform: scale(0);
    animation: scaleUp 0.3s forwards;
}

@keyframes fadeIn {
    to {
        opacity: 1;
    }
}

@keyframes scaleUp {
    to {
        transform: scale(1);
    }
}

.custom-button {
    padding: 10px 20px;
    background-color: #e6e6e6;
    color: #000b82;
    text-align: center;
    font-weight: 500;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s ease;
}

.custom-button:hover {
    background-color: #d6d6d6;
}

.profile-action-btn {
    display: block;
    width: 100%;
    background: #f3f6fb;
    color: #2355b3 !important;
    padding: 12px 0;
    border: 1.5px solid #2355b3;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    text-decoration: none;
    margin: 12px 0 0 0;
    transition: background 0.2s, color 0.2s, box-shadow 0.2s;
    box-shadow: none;
    cursor: pointer;
    letter-spacing: 0.5px;
}

.profile-action-btn.qr-btn {
    width: 40px;
    height: 40px;
    min-width: 40px;
    min-height: 40px;
    padding: 0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
}

.profile-action-btn:hover {
    background: #2355b3;
    color: #082760 !important;
    box-shadow: 0 2px 8px rgba(35,85,179,0.10);
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.switch-list li.active {
    background: #eef3fc;
}

.switch-check {
    font-size: 22px;
}

/* Match .transactions .item .detail .image-block (w48): same slot size & margin as other rows */
.cal-icon-slot {
    width: 48px;
    min-width: 48px;
    height: 48px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.cal-icon-slot ion-icon {
    font-size: 28px;
    width: 28px;
    height: 28px;
    color: #3788d8;
}

</style>